import { http } from "../config.api.js"
//责任主体监管信息查询平台


//项目督巡查（已发布文件查看列表）
export const pubLished = (pageInfo, params) => {
    return http.get("/dxcList/dxcListQuery/" + pageInfo, { urlParams: params }).then(res => res.data);
};
//项目督巡查（查看督巡查文件）
export const docuMent = params => {
    return http.get("/dxcList/dxcListDetail/", { urlParams: params }).then(res => res.data);
};
//项目督巡查（查询督巡查附件）
export const acceSsory = params => {
    return http.get("/dxcList/dxcListFile/", { urlParams: params }).then(res => res.data);
};
//公示期的合同履约评价单（已失效的合同履约评价单）
export const pubLicity = (pageInfo, params) => {
    return http.get("/spotCheckdyPerform/performsForZRZT/" + pageInfo, { urlParams: params }).then(res => res.data);
};
//合同履约评价查看
export const evaLuate = params => {
    return http.get("/spotCheckdyPerform/performanceView", { urlParams: params }).then(res => res.data);
};


export const correctNoticeListForZRZT = (pageInfo, params) => { return http.get("/spotCheckNotice/correctNoticeListForZRZT/" + pageInfo, { urlParams: params }).then(res => res.data); };
export const correctNoticeView = params => {return http.get("/spotCheckNotice/correctNoticeView", { urlParams: params }).then(res => res.data);};
export const scoreNoticeForZRZT = (pageInfo, params) => { return http.get("/spotCheckScoreNotice/scoreNoticeForZRZT/" + pageInfo, { urlParams: params }).then(res => res.data); };
export const getScoreNoticeInfo = params => {return http.get("/spotCheckScoreNotice/getScoreNoticeInfo", { urlParams: params }).then(res => res.data);};
export const changeLogMatain = params => {return http.get("/spotCheckScoreNotice/changeLogMatain", { urlParams: params }).then(res => res.data);};



// WEBPACK FOOTER //
// ./src/api/project/api_supervision.js